import React from 'react';
import { Link } from 'react-router-dom';

const SmarterCampusCTA = () => {
  return (
    <div className="bg-blue-900 py-16 text-white text-center px-4">
      <div className="container mx-auto">
        <h2 className="font-heading font-bold mb-4 text-2xl md:text-[35px]">
          {/* Use responsive text sizes: text-2xl for mobile, md:text-[35px] for medium screens and up */}
          Let's Build a Smarter Campus Together
        </h2>
        <p className="text-sm md:text-[18px] text-center max-w-2xl mx-auto font-ui mb-8">
          {/* Use responsive text sizes: text-sm for mobile, md:text-[18px] for medium screens and up */}
          Ready to revolutionize your educational institution? Get in touch with our experts and see how Global Solutions can transform your operations.
        </p>
        <div className="bg-blue-800/50 p-6 md:p-11 rounded-lg shadow-lg max-w-full md:max-w-[800px] mx-auto">
          {/* Removed fixed width w-[800px] and used max-w-full for flexibility. Added padding for both mobile and desktop. */}
          <h3 className="font-semibold text-lg md:text-[20px] font-ui mb-4">
            {/* Use responsive text sizes */}
            Get Your Free Consultation
          </h3>
          <p className="text-sm md:text-base mb-6">
            {/* Use responsive text sizes */}
            See Global Solutions ERP in action with a personalized demo tailored to your institution's needs.
          </p>
          <Link to="/freedemo">
            <button className="bg-[#F59E0B] hover:bg-[#f3b541] px-6 py-3 rounded-lg demo-button font-bold text-sm md:text-[17px] font-ui items-center gap-2">
              {/* Use responsive text sizes for the button as well */}
              Book Demo Call
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SmarterCampusCTA;